import { createFileRoute } from "@tanstack/react-router";
import { PasswordResetForm } from "@pages/password-reset/password-reset-form/password-reset-form";

export const Route = createFileRoute("/_passwordreset-layout/passwordreset/")({
  component: PasswordResetForm,
});
